import React, { useEffect } from "react";
import "./App.css";
import { authProtectedRoutes, publicRoutes } from "./Routes/allRoutes";
import { Route, Routes } from "react-router-dom";
import VerticalLayout from "./Layouts/VerticalLayout";
import "./assets/scss/theme.scss";
import NonAuthLayout from "./Layouts/NonLayout";
import AuthProtected from "./Routes/AuthProtected";
import { useNavigate } from "react-router-dom";
import { setGlobalNavigate } from "utils/navigation";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function App() {

  const navigate = useNavigate();
  // This runs once to set global navigate
  useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);

  return (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route path={route.path} key={idx}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>} />
        ))}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <React.Fragment>
                <AuthProtected routePermission={route.permission}>
                  <VerticalLayout>
                    {route.component}
                  </VerticalLayout>
                </AuthProtected>
              </React.Fragment>
            }
          />
        ))}
      </Routes>
      <ToastContainer 
        position="bottom-right"
        hideProgressBar={true}
        autoClose={10000}
        closeOnClick
        pauseOnHover
        draggable
      />
    </React.Fragment>
  );
}

export default App;
